var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512c141.385 0 256-114.615 256-256S397.385 0 256 0 0 114.615 0 256s114.615 256 256 256Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.98 437.02c-99.974-99.975-99.974-262.065 0-362.04C74.974 74.992 222.61 256 222.61 256L74.98 437.02Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.609 256.001 33.953 128.514a255.118 255.118 0 0 0-15.44 31.763l95.51 95.725-95.506 95.73a254.82 254.82 0 0 0 15.426 31.741l188.666-127.472Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.833 222.609H222.602L74.978 74.984a256.99 256.99 0 0 0-41.025 53.53L161.192 256 33.943 383.47a256.966 256.966 0 0 0 41.035 53.545l147.624-147.624h287.231A258.529 258.529 0 0 0 512 256c0-11.317-.744-22.461-2.167-33.391Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.139 459.077C143.308 492.259 197.345 512 256.001 512c118.279 0 217.805-80.221 247.181-189.217H236.434L100.139 459.077Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.182 189.217C473.806 80.221 374.28 0 256.001 0c-58.656 0-112.693 19.741-155.862 52.923l136.294 136.294h266.749Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.c5113ee18a87559e99878753b1c300ac.svg";
export { ForwardRef as ReactComponent };